import Logo from "@/components/layout/Logo"
import { useTranslation } from "react-i18next"

export default function SplashLoader() {
  const { t } = useTranslation()

  return (
    <output
      className="w-full min-h-screen flex items-center justify-center text-muted-foreground"
      aria-live="polite"
      aria-label={t("loading.loading")}
    >
      <div className="flex flex-col items-center gap-8">
        <Logo className="h-10 w-auto animate-pulse" style={{ animationDuration: "2s" }} />
        <span className="text-xs tracking-widest uppercase text-muted-foreground/60">
          {t("loading.loading")}
        </span>
      </div>
    </output>
  )
}
